import { Link, useLocation } from 'react-router-dom';
import PageShell from '../../../components/layout/PageShell';

// ✅ Custom breadcrumbs example:
// const crumbs = [
//   { label: 'Home', to: '/' },
//   { label: 'Community', to: `/community/${communityId}` },
//   { label: 'Match Manager', to: `/community/${communityId}/match-manager/${managerId}` },
//   { label: 'Manual Match Format' },
// ];
// <PageShell breadcrumbs={crumbs}>...</PageShell>
// <PageShell breadcrumbOverrides={{ tournamentId: tournament?.name || 'Tournament' }}>
function NotFoundPage() {
  const location = useLocation();

  return (
    <PageShell containerClassName="p-0">
    <section className="d-flex flex-column align-items-center justify-content-center py-5 gap-3 text-center">
      <p className="badge bg-secondary">404</p>
      <h1 className="display-6 fw-bold">Page not found</h1>
      <p className="text-muted mb-4">
        We couldn&apos;t find a page for
        {' '}
        <code>{location.pathname}</code>
        . Check the URL or return to a known section.
      </p>
      <div className="d-flex gap-3">
        <Link className="btn btn-primary" to="/">
          Go to dashboard
        </Link>
        <Link className="btn btn-outline-secondary" to="/login">
          Back to login
        </Link>
      </div>
    </section>
  
    </PageShell>
  );
}

export default NotFoundPage;
